import { render, staticRenderFns } from "./EditarPrazoDeVencimentoLRFCI.vue?vue&type=template&id=4a4adb83"
import script from "./EditarPrazoDeVencimentoLRFCI.vue?vue&type=script&lang=ts"
export * from "./EditarPrazoDeVencimentoLRFCI.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports